<template>
  <div class="home-headlines" :class="{ 'no-main-news': !mainNews }">
    <!-- headline-title -->
    <a v-if="mainNews" class="headline-title" :href="getNewsUrl(mainNews)" target="_blank">{{ mainNews.title || '' }}</a>
    
    <!-- headline-list -->
    <div class="headline-list flex-row justify-between">
      <a v-for="item in subNewsList" :key="item.newsCode" class="headline-item" :href="getNewsUrl(item)" target="_blank">{{ item.title }}</a>
    </div>
  </div>
</template>

<script>
import request from '../../../api/request'

export default {
  name: 'HomeHeadlines',
  data() {
    return {
      mainNews: null,
      subNewsList: []
    }
  },
  async created() {
    await this.loadRecommendInfo()
  },
  methods: {
    async loadRecommendInfo() {
      try {
        // 获取 main title (第一条新闻)
        const mainRes = await request.post('/api/index/getIndexRecommendInfo', { positionKey: 'index_main_title' })
        if (mainRes.code === 200 && mainRes.data && mainRes.data.newsList && mainRes.data.newsList.length > 0) {
          this.mainNews = mainRes.data.newsList[0]
        }
        
        // 获取 sub title (4 条新闻)
        const subRes = await request.post('/api/index/getIndexRecommendInfo', { positionKey: 'index_sub_title' })
        if (subRes.code === 200 && subRes.data && subRes.data.newsList) {
          this.subNewsList = subRes.data.newsList.slice(0, 4)
        }
      } catch (e) {
        console.error('获取首页推荐信息失败:', e)
      }
    },
    // 跳转到新闻详情页
    getNewsUrl(mainNews) {
      if (!mainNews) return ''
      return `/zp/a/${encodeURIComponent(mainNews.newsCode || '')}`
    }
  }
}
</script>

<style scoped>
.home-headlines {
  width: 1400px;
  height: 144px;
  margin: 0 auto;
  background: #fff;
  padding-top: 28px;
  box-sizing: border-box;
}

/* 当没有 mainNews 时的特殊样式 */
.home-headlines.no-main-news {
  height: 150px;
}
.headline-title {
  display: block;
  width: 1160px;
  height: 53px;
  margin: 0 auto;
  color: rgba(185, 24, 22, 1);
  font-size: 40px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: center;
  white-space: nowrap;
  line-height: 53px;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}
.headline-title:hover {
  text-decoration: underline;
  color: rgba(150, 15, 15, 1);
}
.headline-list {
  width: 1384px;
  height: 31px;
  margin: 8px 0 0 16px;
}
.headline-item {
  width: 340px;
  height: 31px;
  color: rgba(102, 102, 102, 1);
  font-size: 15px;
  font-family: 'ABeeZee', sans-serif;
  text-align: center;
  text-decoration: none;
  line-height: 31px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.headline-item:nth-child(n+2) {
  margin-left: 10px;
}
.headline-item:hover {
  color: rgba(185, 24, 22, 1);
}
</style>
